import { ExpertiseCarBodyTypes } from './vehicle.types';
import { ExpertisePointGroupType } from './expertise-point.types';

// #region Enums
export const enum CustomerQueryCacheKey {
  GetDailyCustomer = 'GetDailyCustomers',
  GetExpertisePackages = 'GetExpertisePackages',
  GetExpertisePackagesByGroup = 'GetExpertisePackagesByGroup',
  GetCustomerVehicle = 'GetCustomerVehicle',
  GetCustomerVehiclePhotos = 'GetCustomerVehiclePhotos',
  GetCustomerAbilities = 'GetCustomerAbilities',
  GetCustomerFileFaultDetection = 'GetCustomerFileFaultDetection',
  GetCustomerFile = 'GetCustomerFile',
  HasExpertiseResultFromMachine = 'HasExpertiseResultFromMachine',
  GetGasketLeakTestResult = 'GetGasketLeakTestResult',
  CheckAbilityCompleted = 'CheckAbilityCompleted',
  CheckCustomerEditable = 'CheckCustomerEditable',
  GetCustomerPackageInfo = 'GetCustomerPackageInfo',
  GetAirbagCheckResult = 'GetAirbagCheckResult',
  GetAvailableUpgradePackages = 'GetAvailableUpgradePackages',
}

export enum CustomerExpertiseFileType {
  FaultDetectionResult = 10,
  KMDetectionResult = 20,
  GasketLeakResult = 30,
  KMPhoto = 40,
  ChassisPhoto = 50,
  AirbagCheckResult = 60,
}

export enum ExpertisePackageAbilityDefinitionType {
  BoyaDegisenFormu = 1,
  MikronKaydiFormu = 2,
  KaportaKontrolNotlari = 3,
  MotorMekanikKontrolNotlari = 4,
  EkspertizCihaziTestSonuclari = 5,
  AracFotografiTekli = 6,
  AracFotografiCoklu = 7,
  HasarKaydiSorgulama = 8,
  KMKaydiSorgulama = 9,
  ArizaTespitSonuclari = 10,
  KMTespitSonuclari = 11,
  ContaKacakTespitSonuclari = 12,
  SasiKontrol = 13,
  MotorKontrolFormu = 14,
  IcKontrolFormu = 15,
  YolYardimSertifikasi = 16,
  AracKorumaSertifikasi = 17,
  AltTakimKontrolFormu = 18,
  DisKontrolFormu = 19,
  AirbagKontrol = 20,
  DetayliAracSorgulamaTramer360 = 21,
}

export const enum CustomerStatus {
  Started = 10,
  Completed = 20,
  Cancelled = 30,
}

export const CustomerStatusLabel = new Map<number, string>([
  [CustomerStatus.Started, 'Devam Ediyor'],
  [CustomerStatus.Completed, 'Tamamlandı'],
  [CustomerStatus.Cancelled, 'İptal Edildi'],
]);

export const enum CustomerGasketLeakResultType {
  VeryHigh = 10,
  High = 20,
  Medium = 30,
  Slight = 40,
  NoLeak = 50,
  CouldnotControlled = 60,
}
export const enum CustomerAirbagCheckResultType {
  NoIssue = 10,
  UrgentCheck = 20,
  Processed = 30,
  CouldnotControlled = 40,
}

// #endregion

export interface CustomerVehicle {
  customerId: number;
  kilometer: number;
  fuelTypeId: number;
  gearTypeId: number;
  engineHp: number;
  engineVolume: number;
  colorId: number;
  vehicleTypeId: number;
  modelYear: number;
  modelId: number;
  brandId: number;
  chassisNumber: string;
  engineNumber: string;
  id: number;
  preExpertiseNotes?: string;
  customer?: any;
  brand?: any;
  model?: any;
  vehicleType?: {
    id: number;
    name: ExpertiseCarBodyTypes;
  };
}

export interface UpdateUserInfo {
  id: number;
  name: string;
  surname: string;
  email: string;
}

export interface Customer {
  id: number;

  plate: string;

  displayPlate: string;

  name?: string;

  firmName?: string;

  mersisNo?: string;

  authorizationNo?: string;

  phoneNumber?: string;

  cityId?: number;

  countyId?: number;

  governmentId?: string;

  isIndividual: boolean;

  carLicenceName?: string;

  carLicencePhoneNumber?: string;

  carLicenceCityId?: number;

  carLicenceCountyId?: number;

  carLicenceGovernmentId?: string;

  carLicenceEmail?: string;

  carLicenceAddress?: string;

  carLicenceIsIndividual: boolean;

  carLicenceFirmName?: string;

  expertisePackageId?: number;

  expertisePackageGroupId?: number;

  userId: number;

  canContinue: boolean;

  customerVehicle?: CustomerVehicle;

  status: CustomerStatus;

  hasKvkkApproval: boolean;

  hasIsemriApproval: boolean;

  isAppliedDiscountByCampaign?: boolean;

  email?: string;

  address?: string;

  createdAt?: Date;

  additionalServiceNames?: string[];

  expertisePackage?: {
    id: number;
    name: string;
  };
  updateUserInfo?: UpdateUserInfo;
}

export interface CustomersResponse {
  customers: Customer[];
}

export interface CustomerHistories {
  customerId: number;
  expertiseDate: Date;
  expertisePointId: number;
  expertisePointName: string;
  expertiseReportUrl?: string;
}

export interface CustomerInitiateResponse {
  hasHistoryByPlate: boolean;
  savedCustomerId: number;
  histories: CustomerHistories[];
  fileStatus?: string;
}
export interface CustomerInitiateRequest {
  license: string;
  expertisePackage: string;
  expertisePackageGroup: string;
  packageCode?: string;
  discountApplied?: boolean;
  discountedPrice?: string;
  additionalPackages?: number[];
  authorizationDocumentNumber?: string;
  phoneNumberForDiscount?: string;
}

export interface CustomerResponse {
  customer: Customer;
  isAppliedDiscountByCampaign?: boolean;
  canContinue: boolean;
  displayPlate: string;
  hasKvkkApproval: boolean;
  hasIsemriApproval: boolean;
  updateUserInfo?: UpdateUserInfo;
}

export interface SaveCustomerRequest {
  id: number;

  name: string;

  firmName?: string;

  mersisNo: string;

  authorizationNo: string;

  phoneNumber: string;

  cityId: number;

  countyId: number;

  governmentId: string;

  isIndividual: boolean;

  carLicenceName?: string;

  carLicencePhoneNumber?: string;

  carLicenceCityId?: number;

  carLicenceCountyId?: number;

  carLicenceGovernmentId?: string;

  carLicenceEmail?: string;

  carLicenceAddress?: string;

  carLicenceIsIndividual?: boolean;

  carLicenceFirmName?: string;

  // expertisePackageId: number;

  // expertisePackageGroupId: number;

  email: string;

  address?: string;
}

export interface SaveCustomerVehicleRequest {
  customerId: number;
  engineNumber: string;
  chassisNumber: string;
  brandId: number;
  modelId: number;
  modelYear: number;
  vehicleTypeId: number;
  colorId: number;
  fuelTypeId: number;
  gearTypeId: number;
  engineHp: number;
  engineVolume: number;
  kilometer: number;
  preExpertiseNotes?: string;
}

export interface GetCustomerVehicleResponse {
  customerVehicle: CustomerVehicle;
}

export interface SaveCustomerVehiclePhotoRequest {
  customerId: number;
  file: File;
  id?: number;
}

export interface OcrLicencePhotoRequest {
  files: File;
}

export interface CustomerVehiclePhoto {
  id: number;
  photoUrl: string;
}

export interface CustomerVehiclePhotosResponse {
  customerVehiclePhotos: CustomerVehiclePhoto[];
}

export interface CustomerAbilityDefinition {
  abilityDefinitionType: ExpertisePackageAbilityDefinitionType;
  abilityDefinitionTypeValue: any;
  hasAbility: boolean;
}

export interface CustomerAbilityDefinitionAllResponse {
  customerId: number;
  abilityDefinitions: CustomerAbilityDefinition[];
}

export type CustomerAbilityDefinitionTable = {
  [key in ExpertisePackageAbilityDefinitionType]: boolean;
};

export interface CustomerTestResultFile {
  id: number;
  url: string;
  customerId: number;
}
export interface CustomerTestResultFileUploadResponse {
  id: number;
  url: string;
  customerId: number;
}

export interface SendKvKKRequestResponse {
  alreadyApproved: boolean;
  smsSent: boolean;
  customerData: Customer;
}

export interface SearchCustomerParams {
  plate?: string;
  chassisNumber?: string;
  startDate?: string;
  endDate?: string;
  brandId?: any;
  modelId?: any;
  vehicleTypeId?: any;
  customerName?: string;
  adminStatusChanged?: string;
  status?: string;
  searchBrandId?: ExpertisePointGroupType;
  customerId?: number;
}

export interface GasLeakInfo {
  customerId: number;
  resultType: CustomerGasketLeakResultType;
}

export interface AirbagCheckInfo {
  customerId: number;
  resultType: CustomerAirbagCheckResultType;
}

export interface CustomerPackageInfo {
  priceWithoutDiscount: number;
  discount: number;
  finalPrice: number;
  packageInfo: {
    name: string;
    price: number;
  };
  additionalServices: {
    name: string;
    price: number;
  }[];
}

export interface GetDiscountedRoyaltyPriceRequest {
  plate: string;
  expertisePackageGroupId: number;
  expertisePackageId?: number;

  packageCode?: string;

  discountApplied?: boolean;

  discountedPrice?: number;

  abilityDefinitionTypes?: [];

  phoneNumberForDiscount?: string;
}

export interface AvailableUpgradePackage {
  id: number;
  name: string;
  price: number;
  priceDifference: number;
  royaltyAmount: number;
}

export interface UpgradePackageRequest {
  newExpertisePackageId: number;
}
